import script from "./commonTop.vue?vue&type=script&setup=true&lang=js"
export * from "./commonTop.vue?vue&type=script&setup=true&lang=js"

import "./commonTop.vue?vue&type=style&index=0&id=0afaed14&lang=less"

const __exports__ = script;

export default __exports__